import React from "react";
import { ClearFilterButton, SearchButton } from "./Buttons";

function TableFilterBox(props) {
  return (
    <div className={`bg-white ${props.extraClass}`} style={props.style}>
      <div className={"bg-white d-flex flex-wrap pl-1 pr-1 pb-2"}>
        {props.children}
      </div>
      {props.button1 && props.button1}
      {props.add && (
        <button
          type="button"
          className="btn btn-sm btn-primary float-right mr-3"
          data-toggle="modal"
          data-target={props.modalId || "#tableEdit"}
          onClick={() => props.add("new")}
        >
          {props.addText || "Create new"}
        </button>
      )}
      {props.export && props.export}

      {props.clearFilter && (
        <ClearFilterButton
          className={`mr-${props.mr}`}
          onClick={props.clearFilter}
        />
      )}
      {props.filter && (
        <SearchButton
          className={`mr-${props.mr}`}
          onClick={props.onFilter}
          text={props.filterText}
        />
      )}
      {props.getInvoices && (
        <button
          className="btn btn-sm float-right mr-3 btn-info"
          onClick={props.getInvoices}
        >
          Gauti sąskaitas
        </button>
      )}
      {props.importPayModulePlans && props.importPayModulePlans}
      <hr />
    </div>
  );
}

TableFilterBox.defaultProps = {
  extraClass: "",
  style: {},
  mr: "3",
};

export default TableFilterBox;
